<template>
  <div class="orderMain order-main-style">
    <template v-if="type === '退租'">
      <div class="return-box">
        <van-tabs v-model="returnTabActive" class="return-tab" @change="handleReturnTabChange">
          <van-tab title="可退租合同" name="可退租合同"></van-tab>
          <van-tab title="退租记录" name="退租记录"></van-tab>
        </van-tabs>
        <div class="return-list-box" v-if="isShowReturnList">
          <tr-list
              :request="listUrlReturn"
              ref="trList"
              :data="{ Type: undefined }"
              :no-data-text="returnTabActive === '可退租合同' ? '当前暂无可退租合同' : '暂无数据'"
          >
            <template slot="list" slot-scope="props">
              <template v-if="returnTabActive === '退租记录'">
                <list-group
                    class="special-style"
                    v-for="(item, index) in props.list" :key="'退租'+index"
                    :tag="item.State"
                    :tag-type="(item.State === '待审核' || item.State === '待处理' || item.State === '不通过' || item.State === '已取消') ? 'info' : (item.State === '待设置金额' || item.State === '待退款审核' || item.State === '待退款' || item.State === '退款中') ? 'warning' : item.State === '退款失败' ? 'danger' : 'success'"
                    style="margin-top: 15px"
                    :top-left-text="item.Type"
                    :top-left-bg-color="item.Type === '合同退款' ? '#FFC107' : '#19C82A'"
                    top-right-label="银行卡"
                    :top-right-value="item.BankNumber"
                    :title="item.FullAddress"
                    :foot-left-value="item.CreateTimeStr"
                    foot-left-label="申请时间">
                  <template slot="content">
                    <div class="item">
                      <svg-icon icon-class="地址" color="#999999"></svg-icon>
                      <div>{{ item.RegionName }}</div>
                    </div>
                    <div class="item" v-if="item.Bank" style="margin-top: 15px">
                      <svg-icon icon-class="银行" color="#999999"></svg-icon>
                      <div>{{ item.Bank }}</div>
                    </div>
                    <div class="item" :style="{marginTop: item.Bank ? '0':'15px'}">
                      <div>
                        <svg-icon icon-class="租金" color="#999999"></svg-icon>
                        申请金额：￥{{ item.Money }}
                      </div>
                      <div>
                        <svg-icon icon-class="押金" color="#999999"></svg-icon>
                        实际退款：￥{{ item.ActualMoney }}
                      </div>
                    </div>
                  </template>
                  <template slot="footRight">
                    <div class="btnSpanOne">
                      <router-link tag="span" replace :to="{path: '/equipment/refundDetail', query: {Id: item.Id, type: '退租', title: '退租详情', backUrl: 'orderMain', backQuery: JSON.stringify({type: '退租', title: '退租',backUrl: $route.query.backUrl})}}">
                        详情
                      </router-link>
                    </div>
                  </template>
                </list-group>
              </template>
              <template v-else>
                <list-group
                    v-for="(item, index) in props.list" :key="'可退租合同'+index"
                    :tag="item.State"
                    :tag-type="(item.State === '待审核' || item.State === '待处理' || item.State === '不通过' || item.State === '已取消') ? 'info' : (item.State === '待设置金额' || item.State === '待退款审核' || item.State === '待退款' || item.State === '退款中') ? 'warning' : item.State === '退款失败' ? 'danger' : 'success'"
                    style="margin-top: 15px"
                    flex-direction = "row-reverse"
                    top-right-label="合同编号"
                    :top-right-value="item.Code"
                    :title="item.FullAddress"
                    :foot-left-value="item.CreateTimeStr"
                    foot-left-label="下单时间">
                  <template slot="content">
                    <div class="item">
                      <svg-icon icon-class="地址" color="#999999"></svg-icon>
                      <div>{{ item.RegionName }}</div>
                    </div>
                    <div class="item" v-if="item.Bank" style="margin-top: 15px">
                      <svg-icon icon-class="银行" color="#999999"></svg-icon>
                      <div>{{ item.Bank }}</div>
                    </div>
                    <div class="item" style="margin-top: 8px">
                      <div>
                        <svg-icon icon-class="租金" color="#999999"></svg-icon>
                        合同金额：￥{{ item.Deposit + item.Price }}
                      </div>
                    </div>
                    <div class="item" style="margin-top: 8px">
                      <div>
                        <svg-icon icon-class="dx" color="#999999"></svg-icon>
                        套餐名称：{{ item.PackageName }}
                      </div>
                    </div>
                    <div class="item" style="margin-top: 8px">
                      <div>
                        <svg-icon icon-class="合同有效期" color="#999999"></svg-icon>
                        套餐起止时间：{{ item.PackageStartTimeStr }}~{{ item.PackageEndTimeStr}}
                      </div>
                    </div>
                  </template>
                  <template slot="footRight">
                    <div class="btnSpanOne" style="background-color: #07C160" @click="repairSelect(item)">
                      去退租
                    </div>
                  </template>
                </list-group>
              </template>
            </template>
          </tr-list>
        </div>
      </div>

    </template>
    <template v-else>
      <tr-list
          :request="listUrl"
          ref="trList"
          :data="{ Type: type === '续租' ? type : undefined }"
      >
        <template slot="list" slot-scope="props">
          <template v-if="type === '续租'">
            <router-link
                v-for="(item, index) in props.list"
                :key="index"
                :to="{
              path: '/userIn/orderDetails',
              query: { Id: item.Id, back: 'back', title: type + '详情' },
            }"
            >
              <van-cell
                  :title="'订 单：' + item.Code"
                  is-link
                  :value="item.State"
                  :label="'创建时间：' + item.CreateTimeStr"
              />
            </router-link>
          </template>
          <template v-else-if="type === '退租'">
            <list-group
                class="special-style"
                v-for="(item, index) in props.list" :key="'退租'+index"
                :tag="item.State"
                :tag-type="(item.State === '待审核' || item.State === '待处理' || item.State === '不通过' || item.State === '已取消') ? 'info' : (item.State === '待设置金额' || item.State === '待退款审核' || item.State === '待退款' || item.State === '退款中') ? 'warning' : item.State === '退款失败' ? 'danger' : 'success'"
                style="margin-top: 15px"
                :top-left-text="item.Type"
                :top-left-bg-color="item.Type === '合同退款' ? '#FFC107' : '#19C82A'"
                top-right-label="银行卡"
                :top-right-value="item.BankNumber"
                :title="item.FullAddress"
                :foot-left-value="item.CreateTimeStr"
                foot-left-label="申请时间">
              <template slot="content">
                <div class="item">
                  <svg-icon icon-class="地址" color="#999999"></svg-icon>
                  <div>{{ item.RegionName }}</div>
                </div>
                <div class="item" v-if="item.Bank" style="margin-top: 15px">
                  <svg-icon icon-class="银行" color="#999999"></svg-icon>
                  <div>{{ item.Bank }}</div>
                </div>
                <div class="item" :style="{marginTop: item.Bank ? '0':'15px'}">
                  <div>
                    <svg-icon icon-class="租金" color="#999999"></svg-icon>
                    申请金额：￥{{ item.Money }}
                  </div>
                  <div>
                    <svg-icon icon-class="押金" color="#999999"></svg-icon>
                    实际退款：￥{{ item.ActualMoney }}
                  </div>
                </div>
              </template>
              <template slot="footRight">
                <div class="btnSpanOne">
                  <router-link tag="span" replace :to="{path: '/equipment/refundDetail', query: {Id: item.Id, type: '退租', title: '退租详情', backUrl: 'orderMain', backQuery: JSON.stringify({type: '退租', title: '退租',backUrl: $route.query.backUrl})}}">
                    详情
                  </router-link>
                </div>
              </template>
            </list-group>
          </template>
          <template v-else-if="type === '换寝'">
            <single-card-group v-for="(item, index) in props.list" :key="'换寝' + index" :data="item"></single-card-group>
          </template>
          <template v-else>
            <!--          top-right-label="报修订单号"-->
            <!--          :top-right-value="items.OrderCode"-->
            <list-group
                class="special-style"
                :tag="items.State"
                :tag-type="items.State === '待处理' ? 'warning' : (items.State === '维修中' || items.State === '已完成') ? 'success' : 'info'"
                v-for="(items, index) in props.list" :key="'报修'+index"
                style="margin-top: 15px"
                :top-left-text="items.Source"
                :top-left-bg-color="items.Source === '微信端' ? '#FFC107' : '#19C82A'"
                :title="items.FullAddress"
                :foot-left-value="items.CreateTimeStr"
                foot-left-label="报修时间">
              <template slot="content">
                <div class="item">
                  <div>
                    <svg-icon icon-class="地址" color="#999999"></svg-icon>
                    {{ items.RegionName }}
                  </div>
                </div>
                <div class="item" style="margin-top: 15px">
                  <div>
                    <svg-icon icon-class="报修内容" color="#999999"></svg-icon>
                    内容：{{ items.Text }}
                  </div>
                </div>
              </template>
              <template slot="footRight">
                <div class="btnSpanOne">
                  <router-link tag="span" replace :to="{path: '/equipment/repairDetail', query: {Id: items.Id, type: '报修', title: '报修详情', backUrl: 'orderMain', backQuery: JSON.stringify({type: '报修', title: '报修',backUrl: $route.query.backUrl})}}">
                    详情
                  </router-link>
                </div>
              </template>
            </list-group>
          </template>
        </template>
      </tr-list>
    </template>

    <van-popup v-model="show" style="width: 100%;height: 100%;" get-container="body">
      <div class="add-popup">
        <div class="orderInfo" v-if="type === '报修'">
          <h1>
            设备信息 <span>{{ repairDetails.State }}</span>
          </h1>
<!--          <p class="lien-text">名称：{{ repairDetails.Name }}</p>-->
          <p class="lien-text">类型：{{ repairDetails.Type }}</p>
          <p class="lien-text">品牌：{{ repairDetails.BizEquipmentVersionInfo.Drand }}</p>
          <p class="lien-text">所属型号：{{ repairDetails.BizEquipmentVersionInfo.FullName }}</p>
          <p class="lien-text">二维码：{{ repairDetails.QRCode }}</p>
        </div>
        <div class="orderInfo" v-else-if="type === '退租'">
          <h1>
            合同信息 <span>{{ repairDetails.State }}</span>
          </h1>
          <p class="lien-text">合同编号：{{ repairDetails.Code }}</p>
          <p class="lien-text">合同金额：{{ repairDetails.Deposit + repairDetails.Price }}</p>
          <p class="lien-text">校区：{{ repairDetails.RegionName }}</p>
          <p class="lien-text">寝室：{{ repairDetails.FullAddress }}</p>
          <p class="lien-text">套餐起止时间：{{ repairDetails.PackageStartTimeStr }}~{{repairDetails.PackageEndTimeStr}}</p>
          <p class="lien-text">合同押金：{{ repairDetails.Deposit }}</p>
          <p class="lien-text">合同租金：{{ repairDetails.Price }}</p>
          <p class="lien-text">设备状态：{{ repairDetails.EquipmentState }}</p>
        </div>
        <div class="orderInfo" v-else>
          <h1>
            订单信息 <span>{{ repairDetails.State }}</span>
          </h1>
          <p class="lien-text">订单号：{{ repairDetails.BizOrderCode }}</p>
          <p class="lien-text">订单金额：{{ repairDetails.BizOrderMoney }}</p>
          <p class="lien-text">校区：{{ repairDetails.RegionName }}</p>
          <p class="lien-text">寝室：{{ repairDetails.FullAddress }}</p>
          <p class="lien-text">套餐起止时间：{{ repairDetails.StarTimeStr }}~{{repairDetails.EndTimeStr}}</p>
          <p class="lien-text">订单押金：{{ repairDetails.PackageDeposit }}</p>
          <p class="lien-text">订单租金：{{ repairDetails.PackagePrice }}</p>
          <p class="lien-text">设备状态：{{ repairDetails.EquipmentState }}</p>
        </div>
        <div class="orderInfo" v-if="ContractDetail.length > 0">
          <h1>
            成员信息：
            <span>{{ ContractDetail[0] ? ContractDetail[0].Type : "" }}</span>
          </h1>
          <p class="lien-text">姓 名：{{ ContractDetail[0].Name }}</p>
          <p class="lien-text">学 号：{{ ContractDetail[0].StudentId }}</p>
          <p class="lien-text">租 金：{{ ContractDetail[0].Price }}</p>
          <p class="lien-text">押 金：{{ ContractDetail[0].Deposit }}</p>
          <p class="lien-text">手机号：{{ ContractDetail[0].Mobile }}</p>
        </div>
        <template v-if="type === '退租'">
          <p class="lien-text">合同押金：</p>
          <van-field v-model="Deposit" oninput="value=value.replace(/^(\d+)\.(\d)(\d).*$/,'$1.$2$3')" type="number" placeholder="请输入金额" @blur="checkMoney('Deposit')" v-scrolltop/>
          <div style="display: flex; justify-content: center"><span style="color: red; margin-top: 5px">{{ errorMsgDeposit }}</span></div>
          <p class="lien-text">合同租金：</p>
          <van-field v-model="Price" oninput="value=value.replace(/^(\d+)\.(\d)(\d).*$/,'$1.$2$3')" type="number" placeholder="请输入金额" @blur="checkMoney('Price')" v-scrolltop/>
          <div style="display: flex; justify-content: center"><span style="color: red; margin-top: 5px">{{ errorMsgPrice }}</span></div>
          <p class="lien-text"><span style="color: red">*</span>银行卡号：</p>
          <van-field v-model="BankNumber" placeholder="请输入银行卡号" v-scrolltop/>
          <div style="display: flex; justify-content: center"><span style="color: red; margin-top: 5px">{{ errorMsg }}</span></div>
          <van-cell style="padding: 12px;" title="开户银行" is-link :value="Bank" @click="showBank">
            <template #title>
              <span style="color: #999;font-size: 14px;"><span style="color: red">*</span>开户银行：</span>
            </template>
          </van-cell>
          <div style="display: flex; justify-content: center"><span style="color: red; margin-top: 5px">{{ errorBankMsg }}</span></div>
        </template>


        <p class="lien-text"><span style="color: red">*</span>{{ type === "退租" ? "退租原因：" : "描述：" }}</p>
        <van-field v-model="text" type="textarea" :placeholder="type === '退租' ? '请输入退租原因' : '请输入描述'" v-scrolltop/>
        <div style="display: flex; justify-content: center">
          <span style="color: red; margin-top: 5px">{{ errorMessage }}</span>
        </div>
        <div class="footer-btn-order-main">
          <van-button size="small" @click="handleCancel">取消</van-button>
          <van-button size="small" type="primary" :disabled="allowed" @click="rule">提交</van-button>
        </div>
      </div>

    </van-popup>


<!--    <template v-if="type !== '退租'">-->
<!--      <div id="add-order" v-if="type === '报修' ? showRepairBtn : true">-->
<!--        <float-icon @click.native="addOrder">-->
<!--          <van-icon name="add" size="1.2rem" color="#00d8a0"/>-->
<!--        </float-icon>-->
<!--      </div>-->
<!--    </template>-->
    <div id="add-order" class="add-order-new-style" v-if="type === '退租' ? false : (type === '报修' ? showRepairBtn : true)">
      <div class="bg" @click="addOrder">
        <van-icon name="plus" size="30px" color="#fff" />
        <div>{{ type === '退租' ? '退租申请' : type === '报修' ? '报修申请' : '换寝申请'}}</div>
      </div>
    </div>

    <van-popup v-model="EffectiveListShow" position="bottom" style="border-radius: 0; max-height: 80%">
      <tr-list
          v-if="EffectiveListShow"
          request="/BizMemberParentOrder/MyList"
          :control="true"
          ref="trList2"
          @listData="listData"
          :data="{ Type: type === '续租' ? '租赁' : undefined }"
      >
        <template slot="list" slot-scope="props">
          <van-loading v-if="!props.list"/>
          <template v-if="type === '续租'">
            <router-link v-for="(item, index) in props.list" :key="index" :to="{ path: '/equipment/renewalDetail', query: { Id: item.Id } }">
              <van-cell :title="'订 单：' + item.Code" is-link :value="item.State" :label="'创建时间：' + item.CreateTimeStr"/>
            </router-link>
          </template>
          <template v-else-if="type === '退租'">
            <div class="list-centent">
              <div class="list-group" v-for="(item, index) in props.list" :key="index" @click="repairSelect(item)">
                <h1>
                  合同编号：{{ item.Code }} <span>{{ item.State }}</span>
                </h1>
                <p class="lien-text">合同金额：{{ item.Deposit + item.Price }}</p>
                <p class="lien-text">下单时间：{{ item.CreateTimeStr }}</p>
                <p class="lien-text">校区：{{ item.RegionName }}</p>
                <p class="lien-text">寝室：{{ item.FullAddress }}</p>
                <p class="lien-text">套餐名称：{{ item.PackageName }}</p>
                <p class="lien-text">套餐起止时间：{{ item.PackageStartTimeStr }}~{{ item.PackageEndTimeStr}}</p>
              </div>
            </div>
          </template>
          <template v-else>
            <!--报 修-->
            <div class="list-centent">
              <div class="list-group" v-for="(item, index) in props.list" :key="index" @click="repairSelect(item)">
                <h1>
                  订单号：{{ item.BizOrderCode }} <span>{{ item.State }}</span>
                </h1>
                <p class="lien-text">订单金额：{{ item.BizOrderMoney }}</p>
                <p class="lien-text">下单时间：{{ item.CreateTimeStr }}</p>
                <p class="lien-text">校区：{{ item.RegionName }}</p>
                <p class="lien-text">寝室：{{ item.FullAddress }}</p>
                <p class="lien-text">套餐名称：{{ item.PackageName }}</p>
                <p class="lien-text">套餐起止时间：{{ item.StarTimeStr }}~{{ item.EndTimeStr }}</p>
              </div>
            </div>
          </template>
        </template>
      </tr-list>
    </van-popup>
    <van-popup v-model="showBankList" get-container="body" position="bottom">
      <van-picker
          :columns="bankList"
          show-toolbar
          title="开户银行"
          @cancel="showBankList = !showBankList"
          @confirm="onConfirm"
      />
    </van-popup>
    <van-popup v-model="changeVisible" style="width: 100%;height: 100%" position="right" get-container="body">
      <change-room v-if="changeVisible" is-popup @cancel="cancelChange" :all-member-list="allMemberList"></change-room>
    </van-popup>
  </div>
</template>

<script>
import repairDetails from "@/views/user/userOrder/repairDetails.vue";
import listGroup from "@/views/modules/listGroup.vue";
import singleCardGroup from "@/views/modules/singleCardGroup.vue";
import changeRoom from "@/views/user/userOrder/components/changeRoom.vue";
export default {
  name: "renewal",
  components: {
    changeRoom,
    listGroup,
    singleCardGroup
  },
  data() {
    return {
      errorBankMsg: '',
      allMemberList: [],
      changeVisible: false,
      showMemberList: false,
      showRepairBtn: false,
      allowed: false,
      repairDetails: {
        BizEquipmentVersionInfo: {}
      },
      ContractDetail: [],
      errorMessage: "",
      errorMsg: "",
      EffectiveListShow: false,
      BankNumber: "",
      Bank: "",
      text: "",
      show: false,
      type: "",
      orderId: "",
      AllEffectiveList: [],
      Price: 0,
      errorMsgPrice: '',
      Deposit: 0,
      errorMsgDeposit: '',
      bankList: [],
      showBankList: false,
      returnTabActive: '可退租合同',
      isShowReturnList: false
    };
  },
  computed: {
    listUrl() {
      return this.$route.query.type === "报修" ? "/BizMemberService/List" : this.$route.query.type === "退租" ? "/BizMemberReturn/MyList" : this.$route.query.type === '换寝' ? '/BizMemberDormitoryApply/PageList' : "/BizMemberOrder/List";
    },
    listUrlReturn() {
      return this.returnTabActive === '可退租合同' ? '/BizMemberParentOrder/MyList' : '/BizMemberReturn/MyList'
    }
  },
  watch: {
    text() {
      this.errorMessage = "";
    },
    BankNumber() {
      this.errorMsg = "";
    },
    Deposit() {
      this.errorMsgDeposit = "";
    },
    Price() {
      this.errorMsgPrice = "";
    },
  },
  methods: {
    cancelChange(type){
      if (type === 'refresh') {
        this.$refs.trList.onRefresh();
      }
      this.changeVisible = false
    },
    checkMoney(type){
      this[type] = !this[type] ? 0 : this[type]
    },
    showBank(){
      this.$set(this,'showBankList', true)
    },
    handleCancel(){
      if (this.$route.query.OrderId && this.$route.query.type === '退租') {
        this.$router.replace({name: 'userOrder', query: { backUrl: 'user' }})
      }
      this.show = false
    },
    async repairSelect(item) {
      this.$set(this, 'Deposit', 0)
      this.$set(this, 'Price', 0)
      this.$set(this, 'BankNumber', '')
      this.$set(this, 'text', '')
      if(this.type === '报修') {
        await this.getEquipment()
        return false
      }
      if(this.type === '退租') await this.getBank()
      this.show = !this.show;
      this.repairDetails = item;
      if (this.show){
        setTimeout(() => {
          this.handleConfirmInfo()
        }, 50)
      }
      // this.getContractDetail();
    },
    handleConfirmInfo() {
      this.$dialog.confirm({
        title: '退款确认',
        message: `请确认遥控器是否已归还至思沃空调服务中心。若未归还/已丢失(将从押金中扣除40元)。`,
        confirmButtonText: '确认并继续',
        cancelButtonText: '取消'
      }).then(() => {
        // on confirm
      })
      .catch(() => {
        this.$router.replace({name: 'home'})
      })
    },
    async getEquipment() {
      try {
        const { Data } = await this.$post('BizMemberEquipment/EquipmentByDormitory')
        this.repairDetails = Data
        this.show = true
      }catch (e) {
        this.show = false
        this.repairDetails = {}
      }
    },
    getContractDetail() {
      this.$post("/BizMemberContractMeember/PageList", {
        ParentOrderId: this.repairDetails.Id,
      }).then((res) => {
        this.ContractDetail = res.Data.List;
      });
    },
    listData(list) {
      this.$toast.loading().clear();
      if (list.length <= 0) {
        this.EffectiveListShow = false;
        this.$toast("暂无有效订单！");
      }
    },
    addOrder() {
      if (this.type === '换寝') {
        this.changeVisible = true
        return false
      }
      this.$toast.loading({
        duration: 1000,
        mask: false,
      });
      if (this.type === '报修') {
        this.repairSelect({})
        return false
      }
      if(this.type === '退租') {
        this.getBank()
      }
      this.EffectiveListShow = !this.EffectiveListShow;
    },
    async getBank() {
      try{
        const { Data } = await this.$post('/BizMemberDictionary/AllList',{ParetnName: '退租开户银行'})
        this.bankList = Data
        this.bankList.forEach((data) => {
          data.text = data.Name;
        });
        this.$set(this,'Bank', '')
      } catch(e){

      }
    },
    onConfirm(value) {
      this.Bank = value.Value;
      this.showBankList = false;
      this.errorBankMsg = ''
    },
    rule() {
      if (this.type === '退租') {
        if (Number(this.Deposit) !== 0) {
          if (!this.Deposit) {
            this.errorMsgDeposit = '退租押金为必填'
            return false
          }else {
            if (Number(this.Deposit) > Number(this.repairDetails.Deposit)){
              this.errorMsgDeposit = '退租押金不能高于合同押金'
              return false
            }
          }
        }
        if (Number(this.Price) !== 0) {
          if (!this.Price) {
            this.errorMsgPrice = '退租租金为必填'
            return false
          }else {
            if (Number(this.Price) > Number(this.repairDetails.Price)){
              this.errorMsgPrice = '退租租金不能高于合同租金'
              return false
            }
          }
        }
      }
      if (this.text.length === 0) {
        this.errorMessage = this.type === "退租" ? "退租原因为必填" : "描述为必填";
        if(this.type === '退租') {
          if (this.BankNumber.length === 0) {
            this.errorMsg = "银行卡号为必填";
          } else {
            const regex = /^\d{19}$/
            if(!regex.test(this.BankNumber)) {
              this.errorMsg = "请输入正确的银行卡号";
            }
          }
          this.errorBankMsg = this.Bank ? '' :'开户银行为必填'
        }
      } else {
        if (this.BankNumber.length === 0 && this.type === '退租') {
          this.errorMsg = "银行卡号为必填";
        } else {
          if (this.type !== '报修') {
            const regex = /^\d{19}$/
            if(!regex.test(this.BankNumber)) {
              this.errorMsg = "请输入正确的银行卡号";
            } else {
              if (this.Bank){
                this.errorBankMsg = ''
                this.sub();
              }else {
                this.errorBankMsg = '开户银行为必填'
              }

            }
          }else {
            this.sub();
          }
        }
      }
    },
    sub() {
      this.allowed = true;
      this.$toast.loading({
        duration: 0,
      });
      let url;
      let params = {
        OrderId: this.repairDetails.BizOrderId || '',
      };
      if (this.type === "退租") {
        url = "/BizMemberReturn/Send";
        params = {
          OrderId: this.repairDetails.BizOrderId,
          Price: this.Price,
          Deposit: this.Deposit,
          BankNumber: this.BankNumber,
          Bank: this.Bank,
          RentReason: this.text,
        };
      } else {
        url = "/BizMemberService/Send";
        params.Text = this.text;
        delete params.OrderId
      }
      this.$post(url, params).then((res) => {
        if (res.Status === 1) {
          this.errorMessage = "";
          this.EffectiveListShow = false;
          this.$toast.loading().clear();
          this.allowed = false;
          this.$toast(res.Message);
          if (this.type === '报修') {
            this.getDormitoryHasEquipment()
          }
          if (this.$route.query.OrderId && this.$route.query.type === '退租') {
            this.$router.replace({name: 'userOrder', query: { backUrl: 'user' }})
          }else {
            this.$refs.trList.onRefresh();
          }
          this.show = !this.show;
        } else {
          this.errorMessage = "";
          this.show = !this.show;
          this.EffectiveListShow = false;
          this.$refs.trList.onRefresh();
          this.$toast.loading().clear();
          this.allowed = false;
          this.$toast.fail(res.Message);
        }
      });
    },
    async getParentOrderInfo() {
      try {
        const params = {
          OrderId: this.$route.query.OrderId
        }
        const { Data } = await this.$post('/BizMemberParentOrder/MyList',params)
        this.repairSelect(Data.List[0])
      }catch (e) {

      }
    },
    async getDormitoryHasEquipment() {
      try {
        const { Data } = await this.$post('/BizMemberEquipment/DormitoryHasEquipment')
        this.showRepairBtn  = Data
      }catch (e) {
        this.showRepairBtn  = false
      }
    },
    handleReturnTabChange(name, title){
     this.isShowReturnList = false
      setTimeout(() => {
        this.isShowReturnList = true
      },10)
    }
  },
  created() {
    this.type = this.$route.query.type;
    if (this.$route.query.type === '报修') this.getDormitoryHasEquipment()
    if (this.type === '退租') this.isShowReturnList = true
  },
  mounted() {
    if (this.$route.query.OrderId) {
      this.getParentOrderInfo()
      if(this.type === '退租') {
        this.getBank()
      }
    }
  }
};
</script>

<style lang="less" scoped>
.card {
  margin: 0.2rem;
  background-color: #fff;

  .content {
    display: flex;
    padding: 0.5rem;
    justify-content: space-between;
  }

  .rightButton {
    display: flex;
    align-items: center;
  }
}

.list-group,
.orderInfo {
  padding: 12px 15px;
  box-sizing: border-box;
  line-height: 18px;
  position: relative;
  background-color: #fff;
  color: #323233;
  font-size: 0.373333rem;
  overflow: hidden;

  h1 {
    font-weight: normal;
    font-size: 16px;

    span {
      color: #969799;
      float: right;
    }
  }

  &:after {
    content: " ";
    position: absolute;
    pointer-events: none;
    box-sizing: border-box;
    left: 0.4rem;
    right: 0;
    bottom: 0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    border-bottom: 0.026667rem solid #ebedf0;
  }

  p {
    line-height: 20px;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }
}
</style>
<style lang="less">
.orderMain {
  .icon-add-50 {
    i {
      &::before {
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        box-shadow: 0 10px 10px rgba(0, 216, 160, 0.2);
      }
    }
  }

  .van-field__body {
    height: 100%;
  }

  textarea {
    min-height: 100% !important;
    height: 100%;
    display: block;
  }

  .van-popup {
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }


}

.add-popup{
  position: relative;
  height: 100%;
  width: 100%;
  overflow-y: auto;

  .footer-btn-order-main {
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: center;
    button:nth-child(1){
      margin-right: 30px;
    }
    button{
      border-radius: 6px;
      width: 50px;
    }
  }
}
</style>
<style lang="less" scoped>
.order-main-style{
  .add-order-new-style{
    z-index: 100;
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-40%);
    width: 130px;
    height: 58px;
    .bg{
      border: 2px solid #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      color: #ffffff;
      background-color: #00d8a0;
      box-shadow: 0 5px 14.72px 1.28px rgba(0, 63, 47, 0.28);
      border-radius: 30px;
    }
  }


  .return-box{
    height: 100%;
    .return-tab{
      position: fixed;
      width: 100%;
      left: 0;
      top: 46px;
      z-index: 10;
    }
    .return-list-box{
      padding-top: 46px;
    }
  }



}
.orderMain{

  ::v-deep.special-style {
    .title{
      margin: 15px 0 0 0 !important;
    }
  }

  .btnSpanOne{
    float: right;
    background-color:#898989;
    color: #ffffff;
    line-height: 26px;
    padding: 0 12.5px;
    border-radius: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      font-size: 12px;
    }
    >span {
      padding: 0 5px;
    }
  }
  .btnSpanTwo{
    background-color:#19C82A;
    color: #ffffff;
    display: inline-block;
    height: 26px;
    padding: 0 15px;
    margin-right: -13px;
    border-radius: 14px;
  }
  .item{
    color: #999999;
    display: flex;
    align-items: center;
    line-height: 24px;
    > div {
      display: flex;
      align-items: center;

      &:nth-child(1) {
        margin-right: 20px;
      }
    }

    .svg-icon {
      font-size: 16px !important;
    }
  }

  .addr{
    color: #999999;
    display: flex;
    line-height: 24px;
  }

  .yxq{
    display: flex;
    >div{
      line-height: 24px;
    }
  }
}
</style>
